import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, View } from 'react-native';
import TableMobile from '@components/table/TableMobile';
import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';
import { ButtonSticky } from '@components/screen/Layout';
import Colors from '@global/colors';
import { actionWidth, limit } from './TodoVisibilityUpdate.utils';
import BrandItem from './BrandItem';
import OtherProductsFooter from './OtherProductsFooter';

const VisibilityBrowseSection = ({
  getBrandsLoading = false,
  loading = {},
  listBrand = [],
  scannedEAN = '',
  isBarcodeScanning = false,
  setScannedEAN = () => {},
  setIsBarcodeScanning = () => {},
  onSearchProducts = () => {},
  searchQuery = '',
  setShowScanner = () => {},
  handleRemoveScannedEAN = () => {},
  isSearch = false,
  onExpand = () => {},
  selectedBrand = [],
  listProduct = {},
  empty = {},
  loadingMore = {},
  skip = {},
  lastPayload = [],
  detailData = {},
  detailTodo = {},
  handleProductUpdate = () => {},
  customerAddress = {},
  navigation = {},
  lastPayloadOther = [],
  setLastPayloadOther = () => {},
  isHasSearchLoadMore = false,
  setShowProduct = () => {},
  setSearchQuery = () => {},
  accountGroupId = null,
  isValueSellOutOnly = false,
}) => {
  return (
    <>
      <TableMobile
        placeholder="Search by name / brand"
        loading={(getBrandsLoading && !listBrand?.length) || loading.search}
        useLegendList={false}
        onSearch={(val) => {
          setSearchQuery(val);
          if (scannedEAN && val !== scannedEAN && val.trim().length > 0) {
            setScannedEAN('');
          }
          if (isBarcodeScanning && val !== scannedEAN) {
            setIsBarcodeScanning(false);
          }
          onSearchProducts({ keyword: val });
        }}
        withFetch={true}
        tableData={listBrand}
        delay={1000}
        searchValue={searchQuery}
        searchInputProps={{
          onScan: () => setShowScanner(true),
          scannedEAN,
          onRemoveScannedEAN: handleRemoveScannedEAN,
        }}
        renderItem={({ data, index }) => (
          <BrandItem
            data={data}
            index={index}
            isSearch={isSearch}
            onExpand={onExpand}
            selectedBrand={selectedBrand}
            loading={loading}
            listProduct={listProduct}
            limit={limit}
            empty={empty}
            loadingMore={loadingMore}
            skip={skip}
            onSearchProducts={onSearchProducts}
            lastPayload={lastPayload}
            detailData={detailData}
            detailTodo={detailTodo}
            setLastPayload={(val) => handleProductUpdate(val, false)}
            customerAddress={customerAddress}
            navigation={navigation}
            accountGroupId={accountGroupId}
            isValueSellOutOnly={isValueSellOutOnly}
          />
        )}
        footerComponent={true}
        renderFooterStatic={
          <OtherProductsFooter
            isSearch={isSearch}
            lastPayloadOther={lastPayloadOther}
            listProduct={listProduct}
            detailData={detailData}
            detailTodo={detailTodo}
            setLastPayloadOther={setLastPayloadOther}
            handleProductUpdate={handleProductUpdate}
            customerAddress={customerAddress}
            navigation={navigation}
            isHasSearchLoadMore={isHasSearchLoadMore}
            loadingMore={loadingMore}
            skip={skip}
            limit={limit}
            onSearchProducts={onSearchProducts}
            searchKeyword={searchQuery}
            accountGroupId={accountGroupId}
            isValueSellOutOnly={isValueSellOutOnly}
          />
        }
      />
      <ButtonSticky
        show
        customHost="modal-sticky-button"
        buttons={[
          {
            component: (
              <View style={styles.footerStyle}>
                <Button
                  rounded
                  buttonStyle={styles.submitButton}
                  disabledStyle={styles.submitButton}
                  disabled={!(lastPayload?.length || lastPayloadOther?.length)}
                  title={
                    <SociollaText type="bold" style={styles.submitText}>
                      Submit
                    </SociollaText>
                  }
                  onPress={() => {
                    setShowProduct(false);
                    setScannedEAN('');
                    setSearchQuery('');
                  }}
                />
              </View>
            ),
          },
        ]}
      />
    </>
  );
};

const styles = StyleSheet.create({
  footerStyle: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  submitButton: {
    width: actionWidth,
  },
  submitText: {
    fontSize: 14,
    letterSpacing: 0.5,
    color: Colors.white,
  },
});

VisibilityBrowseSection.propTypes = {
  getBrandsLoading: PropTypes.bool,
  loading: PropTypes.object,
  listBrand: PropTypes.array,
  scannedEAN: PropTypes.string,
  isBarcodeScanning: PropTypes.bool,
  setScannedEAN: PropTypes.func,
  setIsBarcodeScanning: PropTypes.func,
  onSearchProducts: PropTypes.func,
  searchQuery: PropTypes.string,
  setShowScanner: PropTypes.func,
  handleRemoveScannedEAN: PropTypes.func,
  isSearch: PropTypes.bool,
  onExpand: PropTypes.func,
  selectedBrand: PropTypes.array,
  listProduct: PropTypes.object,
  empty: PropTypes.object,
  loadingMore: PropTypes.object,
  skip: PropTypes.object,
  lastPayload: PropTypes.array,
  detailData: PropTypes.object,
  detailTodo: PropTypes.object,
  handleProductUpdate: PropTypes.func,
  customerAddress: PropTypes.object,
  navigation: PropTypes.object,
  lastPayloadOther: PropTypes.array,
  setLastPayloadOther: PropTypes.func,
  isHasSearchLoadMore: PropTypes.bool,
  setShowProduct: PropTypes.func,
  setSearchQuery: PropTypes.func,
  accountGroupId: PropTypes.string,
  isValueSellOutOnly: PropTypes.bool,
};

export default React.memo(VisibilityBrowseSection);
